import { render, staticRenderFns } from "./modifyApprove.vue?vue&type=template&id=4091e209&scoped=true"
import script from "./modifyApprove.vue?vue&type=script&lang=js"
export * from "./modifyApprove.vue?vue&type=script&lang=js"
import style0 from "./modifyApprove.vue?vue&type=style&index=0&id=4091e209&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4091e209",
  null
  
)

export default component.exports